import api from './api';

interface UploadResponse {
  message: string;
  file: {
    id: string;
    path: string;
    originalWidthPx?: number;
    originalHeightPx?: number;
  };
}

/**
 * Uploads a file to the server.
 * @param file The file to upload.
 * @returns A promise that resolves with the upload response data.
 */
export const uploadFile = async (file: File): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append('image', file);

  try {
    const response = await api.post<UploadResponse>('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    // The api instance's interceptor will handle token refresh.
    // We just need to re-throw the error for the component to handle.
    console.error('File upload failed:', error);
    throw error;
  }
};
